import { render, staticRenderFns } from "./CartDiscountPopup.vue?vue&type=template&id=46da3e78&scoped=true&"
import script from "./CartDiscountPopup.vue?vue&type=script&lang=js&"
export * from "./CartDiscountPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46da3e78",
  null
  
)

export default component.exports